<script lang="ts">
  import app from '#app/app'
  import { icon as iconFn } from '#app/lib/icons'
  import { onChange } from '#app/lib/svelte/svelte'
  import { isOpenedOutside } from '#app/lib/utils'
  import type { ClickEvent } from '#app/types/declarations/svelte'
  import type { Url } from '#server/types/common'

  let {
    url,
    text,
    html,
    icon,
    title = $bindable(''),
    light = false,
    dark = false,
    grey = false,
    classNames,
    tinyButton = false,
    stopClickPropagation = true,
  }: {
    url: Url
    text?: string
    html?: string
    icon?: string
    title?: string
    light?: boolean
    dark?: boolean
    grey?: boolean
    classNames?: string
    tinyButton?: boolean
    stopClickPropagation?: boolean
  } = $props()

  const isExternalLink = $derived(url?.[0] !== '/')
  const target: string | undefined = $derived(isExternalLink ? '_blank' : undefined)
  const rel: string | undefined = $derived(isExternalLink ? 'noopener' : undefined)

  $effect(() => {
    onChange(text, () => {
      if (text && !title) title = text
    })
  })

  function onClick (e: ClickEvent) {
    if (stopClickPropagation) e.stopPropagation()
    if (!(isExternalLink || isOpenedOutside(e))) {
      app.navigateAndLoad(url)
      e.preventDefault()
    }
  }
</script>

<a
  href={url}
  {title}
  {target}
  {rel}
  class:light
  class:dark
  class:grey
  class:tiny-button={tinyButton}
  class={classNames}
  onclick={onClick}
>
  <!-- #if blocks are inlined to avoid the insertion of undesired spaces -->
  {#if icon}{@html iconFn(icon)}{/if}{#if html}
    {@html html}
  {:else if text}
    <span class="link-text">{text}</span>
  {/if}
</a>

<style lang="scss">
  @import "general/scss/utils";

  a:not(.tiny-button){
    &.light{
      @include link-light;
    }
    &.dark{
      @include link-dark;
    }
    &.grey{
      @include link-underline-on-hover($grey, $dark-grey);
    }
  }
</style>
